(function () {
  var KEY = 'kostch_reward_v1';

  function load() {
    try {
      return JSON.parse(sessionStorage.getItem(KEY) || '{}');
    } catch (e) {
      return {};
    }
  }

  function save(data) {
    sessionStorage.setItem(KEY, JSON.stringify(data || {}));
  }

  function merge(patch) {
    var data = load();
    Object.keys(patch).forEach(function (k) {
      data[k] = patch[k];
    });
    save(data);
    return data;
  }

  function withPreview(url) {
    if (!url) return url;
    try {
      var u = new URL(url, window.location.origin);
      var cur = new URL(window.location.href);
      if (cur.searchParams.get('preview_theme_id') && !u.searchParams.get('preview_theme_id')) {
        u.searchParams.set('preview_theme_id', cur.searchParams.get('preview_theme_id'));
      }
      return u.pathname + u.search + u.hash;
    } catch (e) {
      return url;
    }
  }

  function go(url) {
    window.location.href = withPreview(url);
  }

  function guard(root) {
    var data = load();
    if (root.dataset.rewardRequireProduct === 'true' && !(data.product && data.product.title)) {
      alert('Please select a product first.');
      go(root.dataset.rewardBack || '/pages/reward-select');
      return false;
    }
    if (root.dataset.rewardRequireReview === 'true' && !(data.reviewBody && data.reviewTitle)) {
      alert('Please complete your review first.');
      go(root.dataset.rewardBack || '/pages/reward-review');
      return false;
    }
    if (root.dataset.rewardRequireGift === 'true' && !data.gift) {
      alert('Please choose a gift first.');
      go(root.dataset.rewardBack || '/pages/reward-gift');
      return false;
    }
    return true;
  }

  function norm(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function esc(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function mediaUrl(media) {
    if (!media) return '';
    if (typeof media === 'string') return media;
    if (media.src) return media.src;
    if (media.preview_image && media.preview_image.src) return media.preview_image.src;
    return '';
  }

  function isBaseOption(name) {
    var n = norm(name);
    return n === 'base color' || n === 'color' || n === 'colour' || n === 'finish';
  }

  function optionNames(product) {
    return (product.options || []).map(function (option) {
      return typeof option === 'string' ? option : (option && option.name) || '';
    });
  }

  function altMatchesColor(alt, optionName, colorName) {
    var text = norm(alt);
    if (!text) return false;
    var needle = norm(optionName + '_' + colorName);
    var color = norm(colorName);
    if (needle && (text.indexOf('#' + needle) !== -1 || text.indexOf(needle) !== -1)) return true;
    return color && text.indexOf(color) !== -1 && text.indexOf('base color') !== -1;
  }

  function colorImage(product, optionName, colorName, variants, optionIndex) {
    var media = product.media || [];
    for (var i = 0; i < media.length; i++) {
      if (altMatchesColor(media[i].alt, optionName, colorName)) return mediaUrl(media[i]);
    }

    var match = '';
    var shared = false;
    variants.forEach(function (variant) {
      var src = mediaUrl(variant.featured_image);
      if (!src) return;
      if (norm(variant['option' + (optionIndex + 1)]) === norm(colorName)) {
        if (!match) match = src;
      } else if (match && src === match) {
        shared = true;
      }
    });
    if (match && !shared) return match;
    return mediaUrl(product.featured_image) || (product.images && product.images[0]) || '';
  }

  function rowsForProduct(product, query) {
    var names = optionNames(product);
    var baseIndex = -1;
    var baseName = '';
    names.forEach(function (name, index) {
      if (baseIndex < 0 && isBaseOption(name)) {
        baseIndex = index;
        baseName = name;
      }
    });

    var variants = product.variants || [];
    var fallbackImage = mediaUrl(product.featured_image) || (product.images && product.images[0]) || '';
    if (baseIndex < 0) {
      return [
        {
          title: product.title,
          handle: product.handle,
          url: '/products/' + product.handle,
          image: fallbackImage,
          vendor: product.vendor || product.type || '',
          sku: (variants[0] && variants[0].sku) || ''
        }
      ];
    }

    var colors = [];
    variants.forEach(function (variant) {
      var color = variant['option' + (baseIndex + 1)];
      if (color && colors.indexOf(color) === -1) colors.push(color);
    });

    var rows = colors.map(function (color) {
      var variant = null;
      variants.forEach(function (item) {
        if (item['option' + (baseIndex + 1)] !== color) return;
        if (!variant || (item.available && !variant.available)) variant = item;
      });
      return {
        title: product.title + ' – ' + color,
        handle: product.handle,
        url: '/products/' + product.handle + (variant ? '?variant=' + variant.id : ''),
        image: colorImage(product, baseName, color, variants, baseIndex),
        vendor: product.vendor || product.type || '',
        sku: (variant && variant.sku) || ''
      };
    });

    var q = norm(query);
    var specific = rows.filter(function (row) {
      var color = norm(row.title.split(' – ').pop());
      var sku = norm(row.sku);
      if (sku && (q === sku || sku.indexOf(q) !== -1 || q.indexOf(sku) !== -1)) return true;
      return color && (q === color || q.indexOf(color) !== -1);
    });
    return specific.length && specific.length < rows.length ? specific : rows;
  }

  function initSelect(root) {
    var data = load();
    var results = root.querySelector('[data-reward-results]');
    var searchInput = root.querySelector('[data-reward-search]');
    var selectedBox = root.querySelector('[data-reward-selected]');
    var timer;
    var requestId = 0;

    function paintSelected(product) {
      if (!selectedBox || !product) return;
      selectedBox.hidden = false;
      var img = selectedBox.querySelector('[data-reward-selected-img]');
      var t = selectedBox.querySelector('[data-reward-selected-title]');
      var v = selectedBox.querySelector('[data-reward-selected-vendor]');
      if (img) {
        img.src = product.image || '';
        img.alt = product.title || '';
      }
      if (t) t.textContent = product.title || '';
      if (v) v.textContent = product.vendor || product.type || '';
    }

    if (data.product) paintSelected(data.product);

    if (searchInput && results) {
      searchInput.addEventListener('input', function () {
        clearTimeout(timer);
        var q = searchInput.value.trim();
        if (q.length < 2) {
          results.hidden = true;
          results.innerHTML = '';
          return;
        }
        timer = setTimeout(function () {
          var url =
            '/search/suggest.json?q=' +
            encodeURIComponent(q) +
            '&resources[type]=product&resources[limit]=8';
          var current = ++requestId;
          fetch(url)
            .then(function (r) {
              return r.json();
            })
            .then(function (payload) {
              var products =
                (payload.resources && payload.resources.results && payload.resources.results.products) ||
                [];
              if (!products.length) {
                if (current !== requestId) return;
                results.innerHTML = '<li class="kostch-reward__empty">No products found</li>';
                results.hidden = false;
                return Promise.resolve([]);
              }
              return Promise.all(
                products.map(function (p) {
                  return fetch('/products/' + encodeURIComponent(p.handle) + '.js')
                    .then(function (r) {
                      return r.json();
                    })
                    .then(function (product) {
                      return rowsForProduct(product, q);
                    })
                    .catch(function () {
                      var thumb = p.image || (p.featured_image && p.featured_image.url) || '';
                      return [
                        {
                          title: p.title,
                          handle: p.handle,
                          url: p.url || '/products/' + p.handle,
                          image: thumb,
                          vendor: p.vendor || p.product_type || '',
                          sku: ''
                        }
                      ];
                    });
                })
              );
            })
            .then(function (groups) {
              if (current !== requestId || !groups) return;
              var rows = [];
              groups.forEach(function (group) {
                rows = rows.concat(group);
              });
              results.innerHTML = '';
              if (!rows.length) {
                results.innerHTML = '<li class="kostch-reward__empty">No products found</li>';
                results.hidden = false;
                return;
              }
              rows.forEach(function (row) {
                var li = document.createElement('li');
                var btn = document.createElement('button');
                btn.type = 'button';
                btn.className = 'kostch-reward__result';
                btn.innerHTML =
                  (row.image
                    ? '<img src="' + esc(row.image) + '" alt="" width="48" height="48">'
                    : '<span class="kostch-reward__result-ph"></span>') +
                  '<span><strong>' +
                  esc(row.title || '') +
                  '</strong><small>' +
                  esc(row.sku || row.vendor || '') +
                  '</small></span>';
                btn.addEventListener('click', function () {
                  var product = {
                    title: row.title,
                    handle: row.handle,
                    url: row.url || '/products/' + row.handle,
                    image: row.image,
                    vendor: row.vendor,
                    type: row.sku
                  };
                  merge({ product: product });
                  paintSelected(product);
                  results.hidden = true;
                  results.innerHTML = '';
                });
                li.appendChild(btn);
                results.appendChild(li);
              });
              results.hidden = false;
            })
            .catch(function () {
              if (current !== requestId) return;
              results.innerHTML = '<li class="kostch-reward__empty">Search unavailable</li>';
              results.hidden = false;
            });
        }, 280);
      });
    }

    var nextBtn = root.querySelector('[data-reward-next-btn]');
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var cur = load();
        if (!(cur.product && cur.product.title)) {
          alert('Please select a product first.');
          return;
        }
        go(root.dataset.rewardNext);
      });
    }
  }

  var PHOTO_DB = 'kostch_reward_photos';
  var PHOTO_MAX = 6;
  var PHOTO_MIN = 1;
  var PHOTO_BYTES = 10 * 1024 * 1024;

  function openPhotoDb() {
    return new Promise(function (resolve, reject) {
      var req = indexedDB.open(PHOTO_DB, 1);
      req.onupgradeneeded = function () {
        req.result.createObjectStore('photos', { keyPath: 'id' });
      };
      req.onsuccess = function () { resolve(req.result); };
      req.onerror = function () { reject(req.error); };
    });
  }

  function savePhotos(items) {
    return openPhotoDb().then(function (db) {
      return new Promise(function (resolve, reject) {
        var tx = db.transaction('photos', 'readwrite');
        tx.objectStore('photos').put({
          id: 'list',
          items: items.map(function (item) {
            return { name: item.name, type: item.type, blob: item.blob };
          })
        });
        tx.oncomplete = function () { resolve(); };
        tx.onerror = function () { reject(tx.error); };
      });
    });
  }

  function loadPhotos() {
    return openPhotoDb().then(function (db) {
      return new Promise(function (resolve, reject) {
        var tx = db.transaction('photos', 'readonly');
        var req = tx.objectStore('photos').get('list');
        req.onsuccess = function () { resolve((req.result && req.result.items) || []); };
        req.onerror = function () { reject(req.error); };
      });
    }).catch(function () { return []; });
  }

  function clearPhotos() {
    return openPhotoDb().then(function (db) {
      return new Promise(function (resolve) {
        var tx = db.transaction('photos', 'readwrite');
        tx.objectStore('photos').delete('list');
        tx.oncomplete = function () { resolve(); };
        tx.onerror = function () { resolve(); };
      });
    }).catch(function () {});
  }

  function isPhotoFile(file) {
    var type = (file.type || '').toLowerCase();
    var name = (file.name || '').toLowerCase();
    return type === 'image/jpeg' || type === 'image/png' || /\.jpe?g$/.test(name) || /\.png$/.test(name);
  }

  function initUploads(root) {
    var grid = root.querySelector('[data-reward-uploads]');
    var input = root.querySelector('[data-reward-file]');
    var errorEl = root.querySelector('[data-reward-upload-error]');
    if (!grid || !input) return { files: function () { return []; }, ready: Promise.resolve() };
    var files = [];
    var replaceIndex = null;

    function showError(message) {
      if (!errorEl) return;
      errorEl.hidden = !message;
      errorEl.textContent = message || '';
    }

    function emptyMarkup(slot) {
      if (slot.getAttribute('data-reward-slot') === '0') {
        return '<span class="kostch-reward__slot-empty"><svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M4 8.5h3.1l1.4-2h7l1.4 2H20a1 1 0 0 1 1 1V18a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9.5a1 1 0 0 1 1-1z"></path><circle cx="12" cy="13.2" r="3.1"></circle></svg><span>Click to upload or drag and drop.<br>JPG, PNG up to 10MB each</span></span>';
      }
      return '<span class="kostch-reward__slot-empty" aria-hidden="true">+</span>';
    }

    function render() {
      grid.querySelectorAll('[data-reward-slot]').forEach(function (slot) {
        var index = Number(slot.getAttribute('data-reward-slot'));
        var item = files[index];
        slot.classList.toggle('is-filled', !!item);
        if (!item) {
          slot.innerHTML = emptyMarkup(slot);
          return;
        }
        slot.innerHTML = '<img alt="" src="' + item.url + '"><button type="button" class="kostch-reward__slot-remove" data-reward-remove="' + index + '" aria-label="Remove image">×</button>';
      });
    }

    function remember(next) {
      var keep = next.slice(0, PHOTO_MAX);
      files.forEach(function (item) {
        if (keep.indexOf(item) === -1 && item.url) URL.revokeObjectURL(item.url);
      });
      files = keep;
      files.forEach(function (item) {
        if (!item.url) item.url = URL.createObjectURL(item.blob);
      });
      render();
      return savePhotos(files);
    }

    function takeFiles(list, index) {
      var incoming = Array.prototype.slice.call(list || []);
      var rejected = '';
      var accepted = [];
      incoming.forEach(function (file) {
        if (!isPhotoFile(file)) {
          rejected = 'Please upload JPG or PNG images only.';
          return;
        }
        if (file.size > PHOTO_BYTES) {
          rejected = 'Each image must be 10MB or smaller.';
          return;
        }
        accepted.push({ name: file.name, type: file.type || 'image/jpeg', blob: file });
      });
      var next = files.slice();
      if (index != null && accepted.length) {
        next[index] = accepted[0];
      } else {
        accepted.forEach(function (item) {
          if (next.length < PHOTO_MAX) next.push(item);
        });
        if (files.length + accepted.length > PHOTO_MAX) rejected = 'You can upload up to 6 images.';
      }
      showError(rejected);
      return remember(next);
    }

    grid.querySelectorAll('[data-reward-slot]').forEach(function (slot) {
      slot.addEventListener('keydown', function (event) {
        if (event.target.closest('[data-reward-remove]')) return;
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        slot.click();
      });
      slot.addEventListener('click', function (event) {
        var remove = event.target.closest('[data-reward-remove]');
        if (remove) {
          event.preventDefault();
          event.stopPropagation();
          var index = Number(remove.getAttribute('data-reward-remove'));
          var next = files.slice();
          next.splice(index, 1);
          showError('');
          remember(next);
          return;
        }
        replaceIndex = files[Number(slot.getAttribute('data-reward-slot'))] ? Number(slot.getAttribute('data-reward-slot')) : null;
        input.value = '';
        input.click();
      });
    });

    input.addEventListener('change', function () {
      var index = replaceIndex;
      replaceIndex = null;
      takeFiles(input.files, index);
    });

    ['dragenter', 'dragover'].forEach(function (name) {
      grid.addEventListener(name, function (event) {
        event.preventDefault();
        var slot = event.target.closest('[data-reward-slot]');
        grid.querySelectorAll('[data-reward-slot]').forEach(function (el) { el.classList.remove('is-drag'); });
        if (slot) slot.classList.add('is-drag');
      });
    });
    grid.addEventListener('dragleave', function (event) {
      var slot = event.target.closest('[data-reward-slot]');
      if (slot) slot.classList.remove('is-drag');
    });
    grid.addEventListener('drop', function (event) {
      event.preventDefault();
      grid.querySelectorAll('[data-reward-slot]').forEach(function (el) { el.classList.remove('is-drag'); });
      var slot = event.target.closest('[data-reward-slot]');
      var index = slot && files[Number(slot.getAttribute('data-reward-slot'))] ? Number(slot.getAttribute('data-reward-slot')) : null;
      takeFiles(event.dataTransfer && event.dataTransfer.files, index);
    });

    var ready = loadPhotos().then(function (items) {
      files = items.map(function (item) {
        return { name: item.name, type: item.type, blob: item.blob, url: URL.createObjectURL(item.blob) };
      });
      render();
    });

    return {
      files: function () { return files; },
      ready: ready
    };
  }

  function initReview(root) {
    if (!guard(root)) return;
    var data = load();
    var uploads = initUploads(root);
    var product = data.product || {};

    var preview = root.querySelector('[data-reward-preview]');
    if (preview) {
      var img = preview.querySelector('[data-reward-preview-img]');
      var title = preview.querySelector('[data-reward-preview-title]');
      var link = preview.querySelector('[data-reward-product-link]');
      if (img) {
        img.src = product.image || '';
        img.alt = product.title || '';
      }
      if (title) title.textContent = product.title || '';
      if (link && product.url) {
        link.href = withPreview(product.url);
        link.hidden = false;
      }
    }

    var jm = root.querySelector('[data-reward-judgeme-link]');
    if (jm && product.url) {
      jm.href = withPreview(product.url + '#judgeme_product_reviews');
    }

    if (data.reviewTitle) root.querySelector('#RewardTitle').value = data.reviewTitle;
    if (data.reviewBody) root.querySelector('#RewardText').value = data.reviewBody;
    if (data.nickname) root.querySelector('#RewardNick').value = data.nickname;
    if (data.email) root.querySelector('#RewardEmail').value = data.email;

    var rating = data.rating || 5;
    var stars = root.querySelector('[data-reward-stars]');
    if (stars) {
      stars.querySelectorAll('[data-star]').forEach(function (btn) {
        btn.classList.toggle('is-on', Number(btn.getAttribute('data-star')) <= rating);
        btn.addEventListener('click', function () {
          rating = Number(btn.getAttribute('data-star'));
          stars.querySelectorAll('[data-star]').forEach(function (s) {
            s.classList.toggle('is-on', Number(s.getAttribute('data-star')) <= rating);
          });
          merge({ rating: rating });
        });
      });
    }

    var recommend = data.recommend || 'Yes';
    root.querySelectorAll('[data-recommend]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-recommend') === recommend);
      btn.addEventListener('click', function () {
        recommend = btn.getAttribute('data-recommend');
        root.querySelectorAll('[data-recommend]').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        merge({ recommend: recommend });
      });
    });

    var nextBtn = root.querySelector('[data-reward-next-btn]');
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var reviewTitle = (root.querySelector('#RewardTitle') || {}).value || '';
        var reviewBody = (root.querySelector('#RewardText') || {}).value || '';
        var nickname = (root.querySelector('#RewardNick') || {}).value || '';
        var email = (root.querySelector('#RewardEmail') || {}).value || '';
        var agree = root.querySelector('[data-reward-field="agree"]');
        if (!reviewTitle || !reviewBody || !nickname || !email) {
          alert('Please complete all required review fields.');
          return;
        }
        var emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).trim());
        if (!emailOk) {
          alert('Please enter a valid email address.');
          var emailInput = root.querySelector('#RewardEmail');
          if (emailInput) emailInput.focus();
          return;
        }
        if (agree && !agree.checked) {
          alert('Please agree to the terms & conditions.');
          return;
        }
        var photos = uploads.files();
        if (photos.length < PHOTO_MIN || photos.length > PHOTO_MAX) {
          alert('Please upload at least 1 image (JPG or PNG, up to 10MB each).');
          return;
        }
        merge({
          rating: rating,
          reviewTitle: reviewTitle,
          reviewBody: reviewBody,
          nickname: nickname,
          email: email,
          recommend: recommend,
          agree: true,
          imageNames: photos.map(function (item) { return item.name; })
        });
        go(root.dataset.rewardNext);
      });
    }
  }

  function initGift(root) {
    if (!guard(root)) return;
    var data = load();
    root.querySelectorAll('[data-gift-value]').forEach(function (input) {
      if (data.gift && input.value === data.gift) input.checked = true;
      input.addEventListener('change', function () {
        merge({ gift: input.value });
      });
    });
    var nextBtn = root.querySelector('[data-reward-next-btn]');
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var cur = load();
        if (!cur.gift) {
          alert('Please choose a free gift.');
          return;
        }
        go(root.dataset.rewardNext);
      });
    }
  }

  function initShipping(root) {
    if (root.querySelector('[data-reward-success]')) {
      sessionStorage.removeItem(KEY);
      clearPhotos();
      return;
    }
    if (!guard(root)) return;
    var data = load();

    root.querySelectorAll('[data-reward-hidden]').forEach(function (el) {
      var key = el.getAttribute('data-reward-hidden');
      if (key === 'productTitle') el.value = (data.product && data.product.title) || '';
      if (key === 'productHandle') el.value = (data.product && data.product.handle) || '';
      if (key === 'gift') el.value = data.gift || '';
      if (key === 'rating') el.value = data.rating || '';
      if (key === 'recommend') el.value = data.recommend || '';
      if (key === 'reviewTitle') el.value = data.reviewTitle || '';
      if (key === 'nickname') el.value = data.nickname || '';
      if (key === 'body') {
        el.value = [
          'Reward claim',
          'Product: ' + (data.product && data.product.title) || '',
          'Handle: ' + ((data.product && data.product.handle) || ''),
          'Rating: ' + (data.rating || ''),
          'Recommend: ' + (data.recommend || ''),
          'Gift: ' + (data.gift || ''),
          'Review title: ' + (data.reviewTitle || ''),
          'Review: ' + (data.reviewBody || ''),
          'Nickname: ' + (data.nickname || ''),
          'Photos: ' + ((data.imageNames && data.imageNames.length) ? data.imageNames.join(', ') : 'none')
        ].join('\n');
      }
    });

    var shipEmail = root.querySelector('[data-reward-ship-email]');
    if (shipEmail && !shipEmail.value && data.email) shipEmail.value = data.email;

    var form = root.querySelector('#KostchRewardShipForm');
    if (form) {
      form.addEventListener('submit', function () {
        /* keep session until success page clears it */
      });
    }
  }

  function boot() {
    document.querySelectorAll('[data-reward-page]').forEach(function (root) {
      var page = root.getAttribute('data-reward-page');
      if (page === 'select') initSelect(root);
      if (page === 'review') initReview(root);
      if (page === 'gift') initGift(root);
      if (page === 'shipping') initShipping(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', boot);
})();
